/*
 * @Description:
 * @Author: HG
 * @Date: 2019-08-21 13:38:08
 * @LastEditors: HG
 * @LastEditTime: 2019-08-28 09:37:33
 */
import Vue from "vue";
import ReportCenterTableComponent from "../reportCenter/reportCenterTable.vue";

const ReportCenterTable = Vue.extend(ReportCenterTableComponent);

const ReportCenterTableModal = options => {
  if (Vue.prototype.$isServer) return;

  const {
    //autoClose,
    ...rest
  } = options;
  const instance = new ReportCenterTable({
    propsData: {
      ...rest
    },
    data: {
      //autoClose: autoClose === undefined ? 3000 : autoClose
    }
  });

  // const id = `SelectPicker`;
  // instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;

  //绑定 change 方法
  //   instance.vm.$on("change", selecteds => {
  //     if (instance.change) {
  //       instance.change(selecteds);
  //     }
  //   });
  instance.vm.$on("destroy", () => {
    document.body.removeChild(instance.vm.$el);
  });
  return instance.vm;
};

export default ReportCenterTableModal;
//export { OrderDetailModal, OrderUpdateModal, CheckInModal, CheckOutModal,OrderLogModal }
